import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { AdminSettingsEditUserMaterialSupplierCustomerModel } from "features/admin/core/domain/admin-settings-edit-user-material-supplier-customer.model";
import {
  AdminSettingsEditUserMaterialSupplierCustomerRepository,
  AdminSettingsEditUserMaterialSupplierCustomerResponse,
} from "features/admin/data/repository/admin.repository";
import { RootState } from "features/config/store";

export enum AdminSettingsEditUserMaterialSupplierCustomerState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: AdminSettingsEditUserMaterialSupplierCustomerState;
  message: string;
  data: AdminSettingsEditUserMaterialSupplierCustomerModel | undefined;
}

const initialState: InitialState = {
  status: AdminSettingsEditUserMaterialSupplierCustomerState.initial,
  message: "",
  data: undefined,
};

export const adminSettingsEditUserMaterialSupplierCustomer = createAsyncThunk(
  "adminSettingsEditUserMaterialSupplierCustomer",
  async (_, { rejectWithValue }) => {
    try {
      const response: AdminSettingsEditUserMaterialSupplierCustomerResponse =
        await AdminSettingsEditUserMaterialSupplierCustomerRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const adminSettingsEditUserMaterialSupplierCustomerSlice = createSlice({
  name: "adminSettingsEditUserMaterialSupplierCustomer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        adminSettingsEditUserMaterialSupplierCustomer.pending,
        (state) => {
          state.status =
            AdminSettingsEditUserMaterialSupplierCustomerState.inProgress;
        }
      )
      .addCase(
        adminSettingsEditUserMaterialSupplierCustomer.fulfilled,
        (state, action) => {
          if (action.payload) {
            const { message, data } = action.payload;

            state.status =
              AdminSettingsEditUserMaterialSupplierCustomerState.success;
            state.message = message;
            state.data = data;
          }
        }
      )
      .addCase(
        adminSettingsEditUserMaterialSupplierCustomer.rejected,
        (state, action) => {
          state.status =
            AdminSettingsEditUserMaterialSupplierCustomerState.fail;
          state.message = action.payload as string;
        }
      );
  },
});

export const selectAdminSettingsEditUserMaterialSupplierCustomer = (
  state: RootState
) => state.adminSettingsEditUserMaterialSupplierCustomer;

export default adminSettingsEditUserMaterialSupplierCustomerSlice.reducer;
